import { Button, Form, Image, Input, Modal, Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { DateFormater } from '../../utils/DateFormater';
import SumFormater from '../../utils/SumFormater';
import { MAIN_URL } from '../../Constants';

function PosHistory(props) {
    let [history, setHistory] = useState([])
    useEffect(() => {
        axios.get('/pos/getsales').then((res) => {
            setHistory(res.data)
        })
    }, [])
    let [open, setOpen] = useState(false)
    let columns = [
        {
            title: 'Tartib raqami',
            dataIndex: 'id',
            key: 'id',
            render: (rec) => <>№ {rec}</>
        },
        {
            title: 'Xaridor',
            dataIndex: 'first_name',
            key: 'first_name',
            render: (text, record) => `${record.first_name} ${record.last_name}`
        },
        {
            title: 'Sotuv amalga oshirilgan vaqt',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (rec) => DateFormater(rec)
        },
        {
            title: "To'landi",
            dataIndex: 'payamount',
            key: 'payamount',
            render: (rec) => SumFormater(rec)
        },
        {
            title: "Qaytim",
            dataIndex: 'returnpay',
            key: 'returnpay',
            render: (rec) => SumFormater(rec)
        },
        {
            title: "Yetkazib narxi",
            dataIndex: 'deliverysumm',
            key: 'deliverysumm',
            render: (rec) => SumFormater(rec)
        },
        {
            title: "Manzil",
            dataIndex: 'deliveraddress',
            key: 'deliveraddress',
        },
    ]
    return (
        <div>
            <h3 style={{padding: '25px 0'}}>Oxirgi savdolar</h3>
            <Modal
                title="Qaytarib olindi"
                open={open}
                footer={null}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Qaytarib olingan soni"
                        name="returncount"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Qaytarib olish narxi"
                        name="returnsumm"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType='submit'>Kiritish</Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Table
                columns={columns}
                bordered
                expandable={{
                    expandedRowRender: (record) => (
                        <Table columns={[
                            {
                                title: 'Rasmi',
                                dataIndex: 'img',
                                key: 'img',
                                render: (rec)=><Image width={50} src={MAIN_URL + '/' + rec} />
                            },
                            {
                                title: 'Maxsulot nomi',
                                dataIndex: 'nameuz',
                                key: 'nameuz',
                            },
                            {
                                title: 'Count',
                                dataIndex: 'quantity',
                                key: 'quantity',
                                render: (rec)=><>{Math.round(rec)} ta</>
                            },
                            {
                                title: 'Narxi',
                                dataIndex: 'price',
                                key: 'price',
                                render: (rec) => SumFormater(rec)
                            },
                            {
                                title: 'Summa',
                                dataIndex: 'summa',
                                key: 'summa',
                                render: (rec) => SumFormater(rec)
                            },
                            {
                                title: 'Sheriklik',
                                dataIndex: 'sheriklik',
                                key: 'sheriklik',
                                render: (sh, rec) => <div style={{ padding: '5px', textAlign: 'center', color: '#fff', height: '25px', borderRadius: '25px', backgroundColor: (sh) ? 'green' : 'gray' }}>Qoldiq: {rec.qoldiq}</div>
                            },
                            {
                                title: 'Qaytarib olindi',
                                key: 'vozvrat',
                                render: (vo, rec) => <Button type="primary" onClick={() => setOpen(true)}>Vozvrat</Button>
                            }
                        ]} dataSource={record.items} rowKey={'id'} />
                    ),
                    rowExpandable: (record) => record.items.length > 0,
                }}
                dataSource={history}
                rowKey='id'
            />
        </div>
    );
}

export default PosHistory;